import React from 'react';
import moment from 'moment';
import GenericFilter from '../shared/tables/GenericFilter';
import DateFilter from '../shared/filters/DateFilter';
import NotificationPreviewModal from './NotificationPreviewModal';

const dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';

const typeOptions = {
  sms: 'SMS',
  mail: 'Email'
};

const eventOptions = {
  apply_confirmation: 'Sollicitatie bevestiging',
  'trial.confirmation': 'Proefdag bevestiging',
  'trial.reminder': 'Proefdag herinnering',
  'trial.second_reminder': 'Proefdag 2e herinnering',
  'mg.confirmation': 'MG bevestiging',
  'mg.reminder': 'MG herinnering',
  no_answer: 'Geen antwoord (SMS)',
  'no_answer.email': 'Geen antwoord (Email)',
  'no_vacancies.email': 'Geen vacatures',
  'invalid_phone_number.email': 'Ongeldig telefoonnummer',
  'non_eu.email': 'Non-EU',
  no_show: 'No-show'
};

const sendStatusOptions = {
  true: 'Verzonden',
  false: 'In wachtrij'
};

const CreateDateFilter = (props) => <DateFilter prefix="create_date" {...props} />;
const SendAfterDateFilter = (props) => <DateFilter prefix="send_after" {...props} />;
const SendOnDateFilter = (props) => <DateFilter prefix="send_on" {...props} />;

export default {
  time: {
    title: 'Tijd',
    column: { filter: CreateDateFilter, sortable: true, name: 'time' },
    value: (row) => row.time && moment(row.time, dateTimeFormat).format('LLL')
  },
  type: {
    title: 'Type',
    options: typeOptions,
    column: { filter: GenericFilter },
    value: (row) => typeOptions[row.type] || row.type
  },
  event: {
    title: 'Event',
    options: eventOptions,
    column: { filter: GenericFilter },
    value: (row) => eventOptions[row.event] || row.event
  },
  receiver: {
    title: 'Ontvanger',
    column: true,
    value: (row) => {
      if (row.receiver_employee) {
        const e = row.receiver_employee;
        return [e.firstname, e.surname_prefix, e.surname].filter((p) => p).join(' ');
      }
      return row.receiver_mail || row.receiver_phone || '-';
    }
  },
  send_after: {
    title: 'Gepland na',
    column: { filter: SendAfterDateFilter, sortable: true },
    value: (row) => row.send_after ? moment(row.send_after, dateTimeFormat).format('LLL') : '-'
  },
  send_on: {
    title: 'Verzonden op',
    column: { filter: SendOnDateFilter, sortable: true },
    value: (row) => row.send_on ? moment(row.send_on, dateTimeFormat).format('LLL') : '-'
  },
  is_send: {
    title: 'Status',
    options: sendStatusOptions,
    column: { filter: GenericFilter },
    value: (row) => (row.send_on ? 'Verzonden' : 'In wachtrij')
  },
  preview: {
    title: '',
    column: true,
    value: (row) => <NotificationPreviewModal uuid={row.uuid} />
  }
};
